var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_19212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19.9282 18 20.8185 17.6312 21.4749 16.9748C22.1312 16.3184 22.5 15.4282 22.5 14.5C22.5 13.5717 22.1312 12.6815 21.4749 12.0251C20.8185 11.3687 19.9282 11 19 11H18C18.1459 10.3499 18.1481 9.68036 18.0065 9.02955C17.8649 8.37873 17.5823 7.75939 17.1748 7.20688C16.7672 6.65437 16.2427 6.17952 15.6313 5.80943C15.0198 5.43934 14.3334 5.18127 13.6111 5.04995C12.8888 4.91863 12.1449 4.91663 11.4218 5.04406C10.6986 5.1715 10.0105 5.42587 9.39658 5.79267C8.15675 6.53343 7.29467 7.68713 6.99999 8.99995C5.93394 8.95725 4.88553 9.27035 4.03426 9.88565C3.18299 10.5009 2.58181 11.3802 2.33366 12.3728C2.08551 13.3654 2.20582 14.4096 2.67399 15.3267C3.14216 16.2438 3.92907 16.9767 4.89999 17.4",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13V22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19L12 22L15 19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_19212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon1);
export default __webpack_public_path__ + "static/media/download_icon 1.25fb86ee0f529fdc31c3bcf98722cbe1.svg";
export { ForwardRef as ReactComponent };